$(document).on('click','.button__quick-view',function(event){
  event.preventDefault();
  $(this).addClass('loading');
  var productHandle = $(this).data('handle');
  var productFileTemplateUrl = '/products/' + productHandle + '?view=product';
  var productFileTemplate = '/products/' + productHandle;
  
  $.ajax({
    type: 'GET',
    url: productFileTemplate,
    dataType : "html",
    success: function(result) {
     var finddiv = $(result).find('.shopify-payment-button').html();
      var ProductPageContent =  $(result).find(".product-section");      
      $('#product-quickview').empty().append(ProductPageContent);
      $("body").addClass("scroll-fixed");
      $(".quickview-model").addClass('open');
      $('.button__quick-view').removeClass('loading');
      $('.model-overlay').addClass('active');
    },
    error: function(status) {
      console.warn('ERROR', status);
    }
  });
});
$(document).on('click','button.quickview-checkout',function(){
  if($('.quickview-checkout').length){
    $(this).addClass('loading');
    var closeSection = $(this).closest('section');
    var variantId = closeSection.find('input.selectedId').val();
    var variantQty = closeSection.find('input.quantity__input').val();
    let host = window.location.hostname;
    let newurl = `//${host}/cart/${variantId}:${variantQty}`
    location.href= newurl;
  }
});
$(document).on('click','.modal__close',function(){
  $("body").removeClass("scroll-fixed");
  $('#product-quickview').empty();
  $(".quickview-model").removeClass('open');
  $('.model-overlay').removeClass('active');
});